export default __webpack_public_path__ + "static/media/gynd-movie.13bbb1f6.mp4";